import { CommentCreatedEvent } from "../Shared/events";
import { user } from '../utils';

const makeCommentCreateEvent = (elementDom) => {
    let sellerSelector = elementDom.querySelector('input[name="productUserId"]');
    
    const makeCommentData = {
        userId: user.id,
        productId: elementDom.querySelector('input[name="productId"]').value,
        productOwnerId: sellerSelector.value,
        isSeller: user.id == sellerSelector.value,
        timeSinceLastComment: elementDom.dataset.timeSinceLastComment,
        isFirstComment: (elementDom.dataset.productTotalComments == 0),
        countrySeller: document.getElementById('product-sheet')?.dataset.biCountrySeller || ''
    }

    const offerCreatedEvent = new CommentCreatedEvent(...Object.values(makeCommentData));
    return offerCreatedEvent;
}

export {
    makeCommentCreateEvent
} 